<template>
  <div class="home" :style="{ '--base-dark': $theme.basedark, '--base-light': $theme.baselight, '--base-color': $theme.basecolor }">
    <div class="row" :style="{ minHeight: 'calc(100vh - 12em)' }">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4" style="min-width: 350px">
        <!-- -------------------------------------------- S I D E P A N E L -------------------------------------------- -->
        <div class="side-bar">
          <div class="sidepanel shadow disabled">
            <div class="row">
              <!-- ---------------- DATEPICKER ---------------- -->
              <div class="col-picker col-10 col-lg-11 col-xl-10">
                <div class="side picker" style="margin-top: 0">
                  <cyb-hotel-date-picker v-model="form.periodo" :labels="labels.datepicker" disabled />
                </div>
              </div>
              <!-- -------------------- NOTTI -------------------- -->
              <div class="col-notti col-2 col-lg-1 col-xl-2">
                <div class="side notti">
                  <fa class="fa moon" :icon="['fas', 'moon']" :title="labels.notti" /><span class="label">{{ form.periodo.notti ? form.periodo.notti : 1 }}</span>
                </div>
              </div>
            </div>
            <!-- -------------------- TOTALI CAMERE -------------------- -->
            <div class="side totali ospiti">
              <div v-for="camera in form.ospiti" :key="camera.key" class="room">
                <div class="room-header">
                  <!-- ---- label ---- -->
                  <div class="room-preno">
                    <div class="room-title">
                      <div>{{ camera_label(camera) }}</div>
                      <div class="room-subtitle">{{ tariffa_label(camera) }}</div>
                    </div>
                    <div class="room-total">
                      <div v-if="_scontata(camera.tariffa)" class="total-price discount-price">
                        <fa :class="'fa euro'" :icon="['fas', $theme.eurosign]" />
                        {{ servizio_prezzo(camera, false) }}
                      </div>
                      <div class="total-price">
                        <fa :class="'fa euro'" :icon="['fas', $theme.eurosign]" />
                        {{ servizio_prezzo(camera) }}
                      </div>
                    </div>
                  </div>
                  <div v-for="(srv, idx) in camera.servizi" :key="idx" class="room-servizi">
                    <div class="room-srv"><fa :class="'fa supp'" :icon="['fas', 'plus']" />{{ srv.titolo }}</div>
                    <div class="room-total">
                      <div class="total-price"><fa :class="'fa euro'" :icon="['fas', $theme.eurosign]" /> {{ srv.prezzo }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- -------------------- TOTALE -------------------- -->
              <div class="rooms-totale-wrapper">
                <div class="rooms-totlabel">
                  {{ labels.Tot }}
                </div>
                <div class="room-total">
                  <div class="total-price"><fa :class="'fa euro'" :icon="['fas', $theme.eurosign]" /> {{ prezzo_totale() }}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- -------------------- DESCRIZIONE PARAMETRIZZABILE DEL CLIENTE -------------------- -->
          <div v-show="this.$store.descsottototali != ''" class="sidepanel shadow">
            <div class="row">
              <div class="col-12 col-sm-12">
                <!-- ---------------- DESCRIZIONE ---------------- -->
                <!-- eslint-disable-next-line vue/no-v-html -->
                <div class="side" style="margin-top: 0" v-html="this.$store.descsottototali"></div>
              </div>
            </div>
          </div>
          <!-- -------------------- BOTTONE AVANTI -------------------- -->
          <!-- <div class="side-btn">
            <div class="bottone cybtn shadow" :style="{ backgroundColor: $theme.basecolor }" @click="finalize()">
              {{ labels.btnConferma }}
              <fa class="fa search" :icon="['fas', 'chevron-right']" />
            </div>
          </div> -->
        </div>
      </div>
      <div class="content-list col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8">
        <!-- -------------------------------------------- C O N T E N T -------------------------------------------- -->
        <div class="content-grazie" :style="{ borderRight: '4px solid ' + $theme.basecolor }">
          <div class="row title">{{ labels.GraziePreno }}</div>
          <div class="wrapper">
            <div class="row">
              <!-- eslint-disable-next-line vue/no-v-html -->
              <div style="margin-bottom: 1.8em" v-html="text"></div>
              <!-- eslint-disable-next-line vue/no-v-html -->
              <div class="subtitle" v-html="policy"></div>
            </div>
          </div>
        </div>
        <div class="btn-footer">
          <div class="btn-avanti cybtn shadow" :style="{ backgroundColor: $theme.basecolor }" @click="reset()">
            {{ labels.btnTorna }}
            <!-- <fa class="fa arrow" :icon="['fas', 'chevron-right']" /> -->
          </div>
        </div>
      </div>
    </div>
    <!-- -------------------------------------------- F O O T E R -------------------------------------------- -->
    <cyb-footer :labels="labels" />
  </div>
</template>

<script>
import CybHotelDatePicker from "../components/cybhoteldatepicker.vue";
import CybFooter from "../components/cybfooter.vue";
import formService from "../services/form";
import apiService from "../services/api.js";
import baseMixin from "../mixins/base";

/**
 * @typedef VueRoute
 * @property {string} path
 * @property {string} fullPath
 * @property {Object.<string,string>} query
 */

/**
 * @typedef XPayConfermaRispostaQueryParameters
 * @property {string} [token] Token della sessione XPay
 * @property {""} xpay__lb__token
 * @property {string} mail
 * @property {string} data Data sotto forma di stringa in formato `YYYYMMDD`
 * @property {string} messaggio Messaggio dell'esito di nexi
 * @property {string} cognome Cognome intestatario carta
 * @property {string} nazionalita Nazionalità intestatario carta
 * @property {string} regione Regione intestatario carta
 * @property {string} mac Codice di autenticazione della chiamata (Message Code Authentication)
 * @property {string} [codAut] Codice dell'autorizzazione assegnato dall'emittente della carta di credito
 * @property {string} tipoProdotto
 * @property {""} selectedcard
 * @property {string} alias alias/apiKey - identificativo del merchant salvato nella tabella AnagAziende come `an_alias`
 * @property {string} pan PIN carta di credito con le prime 6 cifre e/o le ultime 4
 * @property {string} brand Brand carta di credito, vedere tabella {@link https://ecommerce.nexi.it/specifiche-tecniche/tabelleecodifiche/codificatipocarta.html Codifica tipo carta} nella documentazione di Nexi
 * @property {"paga_multi"} tipo_servizio
 * @property {string} orario Ora sotto forma di stringa in formato `hhmmss`
 * @property {"EUR"} divisa Codice della divisa in cui l'importo è espresso
 * @property {string} scadenza_pan Data scadenza PAN sotto forma di stringa in formato `YYYYMMDD`
 * @property {string} importo Importo della transazione
 * @property {string} codiceEsito Codice numerico dell'esito, vedere tabella {@link https://ecommerce.nexi.it/specifiche-tecniche/tabelleecodifiche/codificadescrizioneesito.html Codifica codiceEsito} nella documentazione di Nexi
 * @property {"ITA"} languageId
 * @property {string} nome Nome intestatario carta
 * @property {"PGP"} check Tipologia di pagamento, nel nostro caso solo `PGP` Prenotazione Garantita con Penale
 * @property {"VBV_FULL"} tipoTransazione
 * @property {string} codiceConvenzione
 * @property {string} codTrans Codice transazione generato dal BE, formato `N-<uniqueID>`
 * @property {"PP"} tipo_richiesta
 * @property {string} descrizione Descrizione del prodotto acquistato fornita dal BE
 * @property {"OK"|"KO"|"ERRORE"|"ANNULLO"} esito Esito della transazione
 * @property {""} aliasEffettivo
 * @property {""} OPTION_CF
 * @property {string} num_contratto Numero del contratto / codice esterno della prenotazione, stesso che si trova in `PrenotazioniDati.prd_nroEsterno`
 */

export default {
  components: {
    CybHotelDatePicker,
    CybFooter
  },
  mixins: [baseMixin],
  data() {
    return {
      form: {
        periodo: {
          dataarrivo: "",
          datapartenza: "",
          notti: 0
        },
        ospiti: [],
        numeroprenobe: ""
      },
      content: {},
      text: "",
      policy: "",
      labels: { privacy: {} }
    };
  },
  computed: {
    dataArrivo() {
      return this.form.periodo.dataarrivo ? this.form.periodo.dataarrivo : this.labels.datepicker !== undefined ? this.labels.datepicker["check-in"] : "";
    },
    dataPartenza() {
      return this.form.periodo.datapartenza ? this.form.periodo.datapartenza : this.labels.datepicker !== undefined ? this.labels.datepicker["check-out"] : "";
    }
  },
  /**
   * @this {{ $route: VueRoute & { query: XPayConfermaRispostaQueryParameters } }}
   */
  mounted() {
    // gestione rientro da nexi
    if (typeof this.$route.query.token !== "undefined" && this.$route.query.token.length === 11) {
      apiService.post("BE_form/decodenexi/" + this.$route.query.token, this.$route.query).then((resp) => {
        // un content vuoto arriva dal PHP come array: rimpiazzato, altrimenti codtrans va perso
        this.content = resp.data.content && !Array.isArray(resp.data.content) ? resp.data.content : {};
        this.content.codtrans = resp.codtrans;
        this._fill(this.$hotel, resp.data.hotel);
        this._fill(this.$theme, resp.data.theme);
        this._fill(this.$store, resp.data.store);
        this.$store.form = resp.data.form;
        formService.init(this);

        // gestione differente a seconda dell'esito del pagamento
        switch (this.$route.query.esito) {
          case "OK":
            this.form.numeroprenobe = resp.data.numeroPrenotazione_be;
            if (resp.primo_decode) {
              this.finalize(this.content);
            } else {
              console.warn("Prenotazione già inserita");
            }
            break;
          case "KO":
          case "ERRORE":
          case "ANNULLO":
            this.form.numeroprenobe = "";
            var query = Object.entries(this.$route.query).map(([k, v]) => k + "=" + v);
            // var query = this.$route.fullPath.split("?");
            // query.shift();
            this._goNext("/form?" + query.join("&"));
            break;
        }
      }).catch((err) => {
        // senza i dati di sessione la prenotazione non è salvabile: l'utente va avvisato,
        // il pagamento potrebbe essere comunque andato a buon fine
        this._error(err && err.msg && err.msg.length > 0 ? err.msg : "ERR_NEXI");
      });
    } else {
      formService.init(this);
    }

    this.$root.$on("thanks:reload", () => {
      this.loadContent();
    });
  },
  destroyed() {
    this.$root.$off("thanks:reload");
  },
  methods: {
    // ::::::::::::::::::::::::::::::::: GESTIONE DATI :::::::::::::::::::::::::::::::::
    loadContent() {
      // chiamata backend per recuperare roba
      if (this.$store.db && this.$store.idhotel) {
        apiService.post("BE_grazie/" + this.$store.db + "/" + this.$store.idhotel + "/" + this.$store.lang + "/" + this.$store.idlang, this.form).then((resp) => {
          if (resp) {
            this.text = resp.text;
            this.policy = resp.policy;
          }
        });

        // paramentri mancanti
      } else {
        var err = [];
        if (!this.$store.db || !this.$store.idhotel) {
          err.push("ERR_RPC");
        }
        this._error(err);
      }
    },
    // :::::::::::::::::::::::::::::::: UTILITY ::::::::::::::::::::::::::::::::
    _scontata(tariffa) {
      return typeof tariffa.prezzo_base !== "undefined" && tariffa.prezzo_base !== tariffa.prezzo;
    }
  }
};
</script>

<style lang="scss">
.home {
  // ____________________________ CONTENT ________________________________
  .content-grazie {
    color: #2a364d;
    background-color: white;
    margin: 20px 7px;
    position: relative;
    z-index: 1;
    // padding: 0 10% 2em;
    .title {
      padding: 0.5em 8.8%;
      font-weight: bold;
      margin: 0 0 1em;
      background-color: #c3c9df;
    }
    .wrapper {
      padding: 2em 10% 4em;
      .subtitle {
        font-size: 0.9em;
        display: block;
      }
      .text {
        color: #585858;
        font-size: 0.8em;
      }
      .cyb-input {
        margin: 5px 0;
        border: 1px solid #585858;
        input,
        textarea,
        select {
          background-color: transparent;
          padding: 4px 10px;
          outline: none !important;
          border: none;
          width: 100%;
          &::placeholder {
            opacity: 0.6;
          }
          &[disabled] {
            color: #8d8d8d !important;
            opacity: 1 !important;
            border-color: #8d8d8d !important;
          }
        }
        &.disabled {
          background-color: #e9e9e9 !important;
        }
        textarea {
          margin-bottom: -7px;
        }
        &.cyb-select {
          padding-right: 4px;
          select {
            padding: 6px;
            &:invalid {
              color: #a5a5a5;
            }
            option {
              color: #2a364d;
            }
          }
        }
      }
    }
    .cyb-errore {
      margin-left: 2px;
      color: #e6173a;
      font-size: 0.9em;
      font-style: italic;
    }
  }
}
</style>
